import React, { useState, useEffect } from "react";
import { DndContext, PointerSensor } from "@dnd-kit/core";
import { arrayMove, SortableContext } from "@dnd-kit/sortable";
import { SortableItem } from "./sortable-item";

const IGNORE_TAGS = ["BUTTON"];

export const SortableList = ({ selections, removeValue, disabled, updateOnChange, sectionName }) => {
    const [items, setItems] = useState(selections);

    useEffect(() => {
        setItems(
            selections.sort((a, b) => {
                const aIndex = items.findIndex((item) => item.value === a.value);
                const bIndex = items.findIndex((item) => item.value === b.value);

                if (aIndex === -1) {
                    return 1; // a is not in the items, put it at the end
                } else if (bIndex === -1) {
                    return -1; // b is not in the items, put it at the end
                } else {
                    return aIndex - bIndex; // Sort based on index in items
                }
            })
        );
    }, [selections]);

    useEffect(() => {
        if (items === selections) {
            return;
        }

        updateOnChange(sectionName, items);
    }, [items, selections]);

    const disableDragOnElements = (element) => {
        let current = element;

        while (current) {
            if (IGNORE_TAGS.includes(current.tagName)) {
                return false;
            }

            current = current.parentElement;
        }

        return true;
    };

    PointerSensor.activators = [
        {
            eventName: "onPointerDown",
            handler: ({ nativeEvent: event }) => disableDragOnElements(event.target),
        },
    ];

    const handleDragEnd = ({ active, over }) => {
        if (!over) {
            return;
        }

        if (active.id !== over.id) {
            const oldIndex = items.findIndex((i) => i.value === active.id);
            const newIndex = items.findIndex((i) => i.value === over.id);
            setItems(arrayMove(items, oldIndex, newIndex));
        }
    };

    //The sortable context only accepts simple lists and not objects
    const selectionIds = items.map((sel) => sel.value);

    return (
        <DndContext onDragEnd={handleDragEnd}>
            <div className="flex flex-wrap">
                <SortableContext items={selectionIds}>
                    {items.map((item) => (
                        <SortableItem
                            key={item.value}
                            id={item.value}
                            item={item}
                            removeValue={removeValue}
                            disabled={disabled}
                        />
                    ))}
                </SortableContext>
            </div>
        </DndContext>
    );
};
